const VueCookie = require('vue-cookie') // using require to avoid SSR rejection
import API from "../../services/api"
import http from "../../util/axios";
import { resolve } from "path";
import { rejects } from "assert";

export default {
    namespaced: true,
    state: {
        dashLoader: false,
        highlights:null,
        latestAppointments:null,
        dashboardData: {},
        empMonth: {
          "month" : {
            "label" : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
            "data" : {
              "1" : [10,20,30,10,20,30,20],
              "2" : [5,10,20,20,5,20,10],
              "3" : [8,9,25,15,25,10,5],
              "4" : [6,7,9,8,10,40,2]
            }
          }
        }
    },
    actions: {
        async GET_DASHBOARD_DATA({commit,state}, reqParams) {
          await API.getDashboard(reqParams, function(response){
            return response;
          });            
        },
        SET_DASHLOADER({ commit }, options) {
          commit('setDashLoader', options)
        },
    },
    mutations: {
      setDashLoader: (state, params ) => {
        state.dashLoader = params
      },
    },
    getters: {
      empMonth:(state) => {
        return state.empMonth;
      },
      getDashLoader: (state) => {
        return state.dashLoader;
      },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js